/* global axios */
import ApiClient from '../ApiClient';

class BotFieldsAPI extends ApiClient {
  constructor() {
    super('omni/bot_fields', { accountScoped: true });
  }

  create({ agentBotId, name, description, possibleValues }) {
    return axios.post(this.url, {
      agent_bot_id: agentBotId,
      name,
      description,
      possible_values: possibleValues,
    });
  }

  update(name, { agentBotId, newName, description, possibleValues }) {
    return axios.patch(`${this.url}/${encodeURIComponent(name)}`, {
      agent_bot_id: agentBotId,
      name: newName,
      description,
      possible_values: possibleValues,
    });
  }

  destroy(name, agentBotId) {
    return axios.delete(`${this.url}/${encodeURIComponent(name)}`, {
      params: { agent_bot_id: agentBotId },
    });
  }
}

export default new BotFieldsAPI();
